<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      class="form-control"
      autocomplete="off"
      :id="inputId"
      :disabled="disabled"
      v-model="inputValue"
      @change="emit"
      @input="emit"
      @blur="blur"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <div v-if="!isView">
      <a
        @click="changeVisitorPosition('Водитель')"
        class="transport-owner-helpers"
      >Водитель</a>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'

export default {
  name: 'VisitorPositionInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Должность'
    },

    inputName: {
      default: 'status'
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-status-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-status`
      }

      return inputId
    }
  },

  methods: {
    blur ($event) {
      this.modelValue = this.upperCaseFirst($event.target.value)

      this.emitValue('change', $event.target.value)
    },

    changeVisitorPosition (position) {
      this.visitor.personal.status = position
    },

    upperCaseFirst (str) {
      return str.charAt(0).toUpperCase() + str.substring(1)
    }
  }
}
</script>
